import React, { FC, useCallback } from 'react';
import { Modal } from '@mui/material';
import { OrderDto } from '@sweatpals/shared';
import { CheckoutForm, CheckoutFormProps } from './checkout-form.component';
import CheckoutModalNavBar from './checkout-modal-navbar.component';

export interface CheckoutFormModalProps extends CheckoutFormProps {
	isOpen: boolean;
	onClose(): void;
}

export const CheckoutFormModal: FC<CheckoutFormModalProps> = props => {
	const {
		isOpen,
		onClose,
		onSubmit,
		...checkoutFormProps
	} = props;

	const handleSubmit = useCallback(async (order?: OrderDto): Promise<void> => {
		await onSubmit?.(order);
		onClose();
	}, [onClose, onSubmit]);

	return (
		<Modal open={isOpen}>
			<CheckoutForm
				header={<CheckoutModalNavBar onClose={onClose} />}
				onWarningModalClose={onClose}
				onSubmit={handleSubmit}
				{...checkoutFormProps}
			/>
		</Modal>
	);
};
